import { TYPE_CALC, TYPE_CHECK_BOX, TYPE_DROPDOWN, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT, TYPE_RADIO_BUTTON, TYPE_RICK_TEXT, TYPE_SUB_TABLE } from '@/config/constants';

const mapDataRecord = (valueRecord) => {
    let dataRecord = {};

    Object.keys(valueRecord).forEach((key) => {
        const { type, value } = valueRecord[key];

        if (value && [TYPE_CHECK_BOX, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(type)) {
            dataRecord[key] = value.split(';').filter(Boolean);
        } else if (value && type === TYPE_SUB_TABLE) {
            dataRecord[key] = value.map((elm) => {
                const objData = {
                    id: elm.id,
                    value: {}
                };

                Object.keys(elm.value).forEach((keyTab) => {
                    const tabType = elm.value[keyTab].type;

                    if (elm.value[keyTab] && [TYPE_CHECK_BOX, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(tabType)) {
                        objData.value[keyTab] = {
                            type: tabType,
                            value: elm.value[keyTab].value ? elm.value[keyTab].value.split(';').filter(Boolean) : []
                        };
                    } else if (tabType === TYPE_RICK_TEXT) {
                        objData.value[keyTab] = {
                            type: tabType,
                            value: elm.value[keyTab].value ? elm.value[keyTab].value.replaceAll('<div>', '<p>').replaceAll('</div>', '</p>') : ''
                        };
                    } else if (elm.value[keyTab]) {
                        objData.value[keyTab] = {
                            type: tabType,
                            value: elm.value[keyTab].value || ''
                        };
                    }
                });

                return objData;
            });
        } else if (value && type === TYPE_RICK_TEXT) {
            dataRecord[key] = value.replaceAll('<div>', '<p>').replaceAll('</div>', '</p>');
        } else if (value) {
            dataRecord[key] = value;
        }
    });

    return dataRecord;
};

const mapDataField = (dataField, recordShare) => {
    let listFields = [];

    if (!dataField) return listFields;

    listFields = Object.keys(dataField).map((key) => {
        const fieldItem = { ...dataField[key] };
        const typeField = fieldItem.type;

        if ([TYPE_RADIO_BUTTON, TYPE_CHECK_BOX].includes(typeField)) {
            fieldItem.options = Object.keys(fieldItem.options).map((optionKey) => ({
                label: optionKey,
                value: optionKey
            }));
        } else if (typeField === TYPE_SUB_TABLE) {
            const fieldItems = { ...fieldItem.fields };
            const isEmptyTable = recordShare[fieldItem.code]?.length === 0;
            const objEmpty = {};

            fieldItem.fields = Object.keys(fieldItems).map((keyField) => {
                const subFieldItem = { ...fieldItems[keyField] };

                if (isEmptyTable) {
                    objEmpty[keyField] = {
                        type: subFieldItem.type,
                        value: subFieldItem.defaultValue || ''
                    };
                }

                if (subFieldItem.options) {
                    const optionList = Object.keys(subFieldItem.options).map((optionKey) => ({
                        label: optionKey,
                        value: optionKey
                    }));
                    if (!isEmptyTable) {
                        recordShare[fieldItem.code].forEach((elm) => {
                            if (elm?.value) {
                                Object.keys(elm.value).forEach((keyF) => {
                                    const typeInputCheck = elm.value[keyF].type;
                                    if ([TYPE_CHECK_BOX, TYPE_RADIO_BUTTON].includes(typeInputCheck)) {
                                        elm.value[keyF].options = optionList.sort((a, b) => a.label.localeCompare(b.label));
                                    } else if ([TYPE_DROPDOWN, TYPE_MULTI_SELECT].includes(typeInputCheck)) {
                                        elm.value[keyF].options = Object.keys(subFieldItem.options).sort() || [];
                                    } else if (typeInputCheck === TYPE_CALC) {
                                        elm.value[keyF].format = subFieldItem.format;
                                    }
                                });
                            }
                        });
                    } else {
                        if ([TYPE_CHECK_BOX, TYPE_RADIO_BUTTON].includes(subFieldItem.type)) {
                            objEmpty[keyField].options = optionList.sort((a, b) => a.label.localeCompare(b.label));
                        } else if ([TYPE_DROPDOWN, TYPE_MULTI_SELECT].includes(subFieldItem.type)) {
                            objEmpty[keyField].options = Object.keys(subFieldItem.options).sort();
                        } else if (subFieldItem.type === TYPE_CALC) {
                            objEmpty[keyField].format = subFieldItem.format;
                        }
                    }
                }

                if (subFieldItem.lookup) {
                    if (!isEmptyTable) {
                        recordShare[fieldItem.code].forEach((elm) => {
                            if (elm?.value && keyField in elm.value) {
                                elm.value[keyField].lookup = subFieldItem.lookup;
                            }
                        });
                    } else {
                        objEmpty[keyField].lookup = subFieldItem.lookup;
                    }
                }
                return subFieldItem;
            });

            if (isEmptyTable) {
                recordShare[fieldItem.code] = [{ id: '', value: objEmpty }];
            }
        } else if ([TYPE_DROPDOWN, TYPE_MULTI_SELECT].includes(typeField)) {
            fieldItem.options = Object.keys(fieldItem.options).sort();
        }
        return fieldItem;
    });
    return listFields;
};

export { mapDataRecord, mapDataField };
